.infoText {
  color: var(--body-text-arrows-400);
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer));
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

#content-control-network-monitor-attack-techniques-field {
  width: 100%;
}

.toggle-subtitle {
  color: var(--chart-300-icon-buttons);
}
